// extracted by mini-css-extract-plugin
module.exports = {"no-deployments":"SurveyDeployments_no-deployments__2XCGz"};